export default __webpack_public_path__ + "static/media/SYC.2f5fe75a.svg";